import { userConstants } from "../_constants";

let user = JSON.parse(localStorage.getItem("OLRToolsUser"));

const defaultState = {
  user: null,
  loggedIn: false,
  loggingIn: false,
};
const initialState = user
  ? {
      ...defaultState,
      loggedIn: user ? true : false,
      loggingIn: false,
      user,
    }
  : defaultState;

export function auth(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        loggedIn: false,
        user: null,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        user: action.user,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        loggingIn: false,
        loggedIn: false,
        user: null,
      };
    case userConstants.LOGOUT:
      return {
        ...state,
        loggingIn: false,
        loggedIn: false,
        user: null,
      };
    default:
      return state;
  }
}
